import { useEffect, useRef } from "react"

const usePrevious = <T>(value: T): T | null => {
  const ref = useRef<T | null>(null)

  useEffect(() => {
    ref.current = value
  }, [value])

  // eslint-disable-next-line react-hooks/refs
  return ref.current
}

export default usePrevious
